import React from 'react';
import { TextAlign } from '../../provider/Typo3Provider/types';
import { SectionHeader } from '../Section';
import { Subtitle } from '../Subtitle';
import { Title } from '../Title';
import { HtmlContent } from './HtmlContent';
import { StyledTitleH1 } from '../../containers/SearchContainer/SearchDetail/SearchDetailHead'

interface ContentHeaderProps {
  header?: string;
  subheader?: string;
  doktype?: string | number;
  align?: TextAlign;
}

export const ContentHeader = (props: ContentHeaderProps) => {
  const { header = null, subheader = null, doktype = null } = props;

  if (header) {
    return (
      <SectionHeader>
        {doktype && doktype === 'magazine' ? (
          <Title.Magazine align={props.align}>
            <HtmlContent htmlString={header} />
          </Title.Magazine>
        ) : (
          <StyledTitleH1 align={props.align}>
            <HtmlContent htmlString={header} />
          </StyledTitleH1>
        )}

        {subheader && (
          <Subtitle.H2 align={props.align}>
            <HtmlContent htmlString={subheader} />
          </Subtitle.H2>
        )}
      </SectionHeader>
    );
  }
  return null;
};
